import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 44 44"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "44",
      height: "44",
      fill: "#f8f8f8",
      rx: "12"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#59ad3b",
      d: "m16.805 23.387 2.5 6.23 3.242-3.242 5.547 4.414L32 13.211l-20 8.34 4.805 1.836Zm9.472-5.137-6.113 5.586-.762 2.871-1.406-3.516 8.281-4.941Z"
    }, null, -1)
  ])))
}
export default { render: render }